import React, { useState, useEffect } from 'react';
import LoginHeader from '../../../Login_header';
import Menu from '../../../Menu';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import * as Common from './../../../Common';
import Dialog from './../../../Dialog';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";

const Rep_cheque_status = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [statusCheque, setStatusCheque] = useState("");
    const [statusType, setStatusType] = useState("V");
    const [radioType, setRadioType] = useState("A");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_CHEQUE_STATUS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleGenerate = () => {
        $(".loader").show();
        if (statusCheque === "") {
            setMsgText("Please fill Cheque No.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                statusCheque: statusCheque,
                type: statusType,
                radioTypeLocation: radioType,
            };
            if (statusType === 'D') {
                Common.callDownloadApiPost1(Common.apiChequeStatusReport, "post", [sid, 'getData', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else if (statusType === 'V') {
                Common.callApi(Common.apiChequeStatusReport, [sid, 'getData', JSON.stringify(obj)], (result) => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });
            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Cheque Status Report</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={statusType} onChange={e => setStatusType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Cheque No.<span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Cheque No" maxLength={50}
                                value={statusCheque}
                                onChange={(e) => setStatusCheque(e.target.value)}
                                autoComplete="off" />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_cheque_status
